import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

/**
 * Cross-tab lock with a hard timeout cap so a stuck tab can never freeze
 * the auth session refresh across other tabs.
 */
async function navigatorLock(
  name: string,
  acquireTimeout: number,
  fn: () => Promise<unknown>,
): Promise<unknown> {
  if (typeof navigator === 'undefined' || !navigator.locks) {
    return fn();
  }
  try {
    return await navigator.locks.request(name, { timeout: acquireTimeout }, async (lock) => {
      if (lock) {
        return await fn();
      }
      return fn();
    });
  } catch {
    return fn();
  }
}

let client: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient {
  if (client) return client;

  client = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'tgmci-auth-token',
      lock: navigatorLock,
    },
  });

  return client;
}

export const supabase = getSupabaseClient();